export const DEFAULT_KANBAN_FILTERS = () => ({
  pipelineId: null,
  search: '',
  status: 'open',
  slaStatus: null,
  ownerId: null,
  inboxId: null,
});

export const buildOpportunityFilterParams = ({
  pipelineId,
  status,
  slaStatus,
  ownerId,
  inboxId,
  search,
} = {}) => ({
  pipeline_id: pipelineId,
  status: status || undefined,
  sla_status: slaStatus || undefined,
  owner_id: ownerId || undefined,
  inbox_id: inboxId || undefined,
  search: search || undefined,
});
